import Nullstack from 'nullstack';
export default function IconMeatOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-meat-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M13.62 8.382l1.966 -1.967a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-1.82 1.821"
  }), "   ", Nullstack.element("path", {
    d: "M5.904 18.596c2.733 2.734 5.9 4 7.07 2.829c1.172 -1.172 -.094 -4.338 -2.828 -7.071c-2.733 -2.734 -5.9 -4 -7.07 -2.829c-1.172 1.172 .094 4.338 2.828 7.071z"
  }), "   ", Nullstack.element("path", {
    d: "M7.5 16l1 1"
  }), "   ", Nullstack.element("path", {
    d: "M12.975 21.425c1.582 -1.582 2.679 -3.407 3.242 -5.2"
  }), "   ", Nullstack.element("path", {
    d: "M16.6 12.6c-.16 -1.238 -.653 -2.345 -1.504 -3.195c-.85 -.85 -1.955 -1.344 -3.192 -1.503"
  }), "   ", Nullstack.element("path", {
    d: "M8.274 8.284c-1.792 .563 -3.616 1.66 -5.198 3.242"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}